$(document).on('click', '.mrk-addon-dropdown-item', function () {
    $(this)
    .closest('.mrk-frame-cart-addon-inner')
    .find('.mrk-cart-frame-add')
    .trigger('click');
});


// $(document).on('click', '.wd-menu-drawer-icon', function () {
//   $('.wd-nav-drawer-wrapper details.menu-drawer-container')
//     .removeAttr('open')
//     .removeClass('menu-open');
// });

// $(document).on('click', '.wd-nav-drawer-wrapper details.menu-drawer-container', function () {
//   $('.wd-nav-drawer-wrapper details.menu-drawer-container').not(this)
//     .removeAttr('open')
//     .removeClass('menu-open');
// });